(function () {
  if (window.__productYoutubeEmbedInit) return;
  window.__productYoutubeEmbedInit = true;

  function postToPlayer(iframe, func) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(
      JSON.stringify({ event: 'command', func: func, args: [] }),
      '*'
    );
  }

  function activateEmbed(embed) {
    if (!embed || embed.classList.contains('is-interactive')) return;
    embed.classList.add('is-interactive');

    // Unmute and (re)play via the YouTube iframe API so sound comes on with the
    // first click, alongside the now-interactive native controls.
    var iframe = embed.querySelector('iframe');
    postToPlayer(iframe, 'unMute');
    postToPlayer(iframe, 'playVideo');
  }

  document.addEventListener(
    'click',
    function (event) {
      var shield = event.target.closest('.product-youtube-embed__shield');
      if (!shield) return;
      activateEmbed(shield.closest('.product-youtube-embed'));
    },
    true
  );
})();
